import MainLayout from "Layouts/Main";
import React, { useState } from "react";
import "./styles.scss";
import NormalTabs from "Components/Tabs";
import NotificationSettings from "./NotificationSettings";
import ChangePassword from "./ChangePassword";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Notification Settings", "Change Password"];
  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  return (
    <MainLayout>
      <div className="assessor-setting-container">
        <div className="settingsLabel">Settings</div>
        <div className="mt-4 tabsWrap py-4">
          <NormalTabs
            tabs={tabs}
            activeTab={activeTab}
            handleTab={handleTabChange}
          />
          {activeTab === 0 && (
            <NotificationSettings goToNextTab={() => handleTabChange(1)} />
          )}
          {activeTab === 1 && <ChangePassword goToNextTab={() => handleTabChange(0)}/>}
        </div>
      </div>
    </MainLayout>
  );
};

export default Settings;
